module.exports = __webpack_public_path__ + "fonts/a06baf7.eot";